import moment from "moment";
import { cx } from "shared/utils";
import { THREE_COLS_DRILLDOWN_GRID_CLASSNAME } from "../constants";

export const DrilldownRow = ({
  name,
  contactDetail,
  propertyName,
  propertyAddress,
  unitTitle,
  onClick,
  dates,
  gridClassName
}: {
  name: string;
  contactDetail?: string | null;
  propertyName: string | null;
  propertyAddress?: string | null;
  unitTitle: string | null;
  onClick: () => void;
  dates?: { value: string | null | undefined }[];
  gridClassName?: string;
}) => (
  <div
    className={cx(
      gridClassName ?? THREE_COLS_DRILLDOWN_GRID_CLASSNAME,
      "px-5 py-3 cursor-pointer bg-content-1000-inverted hover:bg-alpha-20"
    )}
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }}
  >
    <div className="min-w-0">
      <p className="text-sm font-medium text-content-700 truncate">{name}</p>
      {contactDetail !== undefined && (
        <p className="text-sm text-content-700 truncate">
          {contactDetail ?? "--"}
        </p>
      )}
    </div>
    <div className="min-w-0">
      <p className="text-sm font-medium text-content-700 truncate">
        {propertyName ?? "--"}
      </p>
      {propertyAddress !== undefined && (
        <p className="text-sm text-content-700 truncate">
          {propertyAddress ?? "--"}
        </p>
      )}
    </div>
    <p className="text-sm font-medium text-content-700 truncate">
      {unitTitle ?? "--"}
    </p>
    {dates?.map((d, i) => (
      <p key={i} className="text-sm font-medium text-content-700 truncate">
        {d.value ? moment(d.value).format("MMM D, YYYY") : "--"}
      </p>
    ))}
  </div>
);
